import { obligationActionResponseSchema, obligationActionSchema, obligationListResponseSchema, type ObligationAction, type ObligationListResponse } from "@io-spoke/contracts/obligations";
import { getApiClient } from "./apiClient";

export async function getOperationalObligations(): Promise<ObligationListResponse> {
  const response = await getApiClient().get("/obligations");
  const parsed = obligationListResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Obligation intelligence returned an invalid response.");
  return parsed.data;
}

export async function applyObligationAction(id: string, action: ObligationAction) {
  const payload = obligationActionSchema.parse(action);
  const response = await getApiClient().post(`/obligations/${id}/actions`, payload);
  const parsed = obligationActionResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Obligation action returned an invalid response.");
  return parsed.data.obligation;
}
